<template>
  <div class="scroll-container">
    <div class="middle-line">
      <div class="btn-circle"></div>
      <div class="btn-circle-active"></div>
      <div class="btn-circle"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ScrollBar",
  props: {
    checkPoints: Number,
  },
  data() {
    return {
      // used for declare local variable to use in this class
      // Syntax : Name of variable : Default value
      // Example => courses: []
    };
  },
  methods: {
    // used for define functions in each case
    // Syntax : Name of method(){ Actions }
    // Example => onLogin(){ this.$store.dispatch('auth/onLogin') }
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped lang="scss">
.scroll-container {
  display: grid;
}
.middle-line {
  width: 5px;
  min-height: 80%;
  border: 3px solid #89abe6;
  border-radius: 20px;
  margin: 50px 0;
  display: grid;
  align-items: center;
}
.btn-circle {
  position: relative;
  right: 7px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #89abe6;
}
.btn-circle:hover {
  background-color: #1d5bd7;
  cursor: pointer;
}
.btn-circle-active {
  position: relative;
  right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #1d5bd7;
}
</style>